const sideViewActionTypes = {
  SAVE_SIDEVIEW_ID: "SAVE_SIDEVIEW_ID",
  FETCH_SIDEVIEW_MOVIE_START: "FETCH_SIDEVIEW_MOVIE_START",
  FETCH_SIDEVIEW_MOVIE_SUCCESS: "FETCH_SIDEVIEW_MOVIE_SUCCESS",
  FETCH_SIDEVIEW_MOVIE_FAILED: "FETCH_SIDEVIEW_MOVIE_FAILED",
};

export default sideViewActionTypes;
